import { mouseEvent } from "../common/mouse_event";
import BookItem from "../common/bookItem";
import AfileChangeBGPicStep from "../afile/afile_change_bg_pic_step";
export default class AfileChangeBGPic extends BookItem {
    constructor(el, target) {
        super(el, target);
        this.connectNumber = this.el.connectNumber;
        this.fileName = el.fileName;
        this.maxNum = el.maxNum;

        this.step = []; //AfileChangeBGPicStep

        //測試用

    }

    init() {
        mouseEvent.add_mouse_event(this);
        this.itemControl.bookItems.forEach(element => {
            if (element instanceof AfileChangeBGPicStep && this.connectNumber == element.connectNumber) {
                this.step.push(element);
            }
        });
    }

    trigger() {
        this.step.forEach(element => {
            element.setBtn(this);
            element.target.visible = false;
        });

        // this.step.forEach(element => {
        //     element.target.visible = false;
        // });

        //這按鈕有多張圖片
        if (this.maxNum > 1) {
            // this.itemControl.bookItems.forEach(element => {
            //     if (element instanceof AfileChangeBGPicStep && this.connectNumber == element.connectNumber) {
            //         if (element.ctrlObjStep == "下一個") {
            //             element.target.visible = true;
            //         }
            //     }
            // });

            this.step.forEach(element => {
                if (element.ctrlObjStep == "下一個") {
                    element.target.visible = true;
                }
            });

        }
        else {
            // this.itemControl.bookItems.forEach(element => {
            //     if (element instanceof AfileChangeBGPicStep && this.connectNumber == element.connectNumber) {
            //         element.target.visible = false;
            //     }
            // });
            this.step.forEach(element => {
                element.target.visible = false;
            });
        }

        //然後換底圖
        this.itemControl.loader.changeBackground(this.fileName);
    }
}